export default __webpack_public_path__ + "static/media/eye.1b15532d.svg";